<div class="answer-buttons-container" [ngClass]="{ visible: actionActive, 'is-people': !model.resources?.length, active: active }">
  @if (displayFeedbackAction) {
    <ng-container *ngTemplateOutlet="feedback"></ng-container>
  }
  <u-icon
    (click)="onCopyContent()"
    class="action-icon"
    [styles]="{ fontSize: '16px', color: 'var(--color-text-secondary)' }"
    [model]="{ type: 'font', value: 'icon-copy-3' }"
    [pTooltip]="'Copy answer' | toggleTooltipText: 'Copied!' : 1000 : tooltip : toggleCopyTooltip() | async"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-icon>
  <u-icon
    *featureFlagEnabled="DISABLED_WIKIS_WORKSPACE_FEATURE_FLAG"
    (click)="onCreateCard()"
    class="action-icon"
    [styles]="{ fontSize: '16px', color: 'var(--color-text-secondary)' }"
    [model]="{ type: 'font', value: 'icon-card' }"
    [pTooltip]="'Create a card'"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-icon>
</div>

<ng-template #feedback>
  <u-icon
    [styles]="{ fontSize: '16px' }"
    [model]="{ type: 'font', value: 'icon-like' }"
    class="action-icon like-icon"
    [ngClass]="{ 'active-feedback': feedbackTypeSelected === 'Positive' }"
    (click)="onShowFeedback($event, 'Positive')"
    pTooltip="Helpful"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-icon>
  <u-icon
    [styles]="{ fontSize: '16px' }"
    [model]="{ type: 'font', value: 'icon-dis-like' }"
    class="action-icon dislike-icon"
    [ngClass]="{ 'active-feedback': feedbackTypeSelected === 'Negative' }"
    (click)="onShowFeedback($event, 'Negative')"
    pTooltip="Not helpful"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-icon>
</ng-template>
